import { render, staticRenderFns } from "./RecadoThreadDialog.vue?vue&type=template&id=25eb8bca&scoped=true"
import script from "./RecadoThreadDialog.vue?vue&type=script&lang=js"
export * from "./RecadoThreadDialog.vue?vue&type=script&lang=js"
import style0 from "./RecadoThreadDialog.vue?vue&type=style&index=0&id=25eb8bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25eb8bca",
  null
  
)

export default component.exports